export enum portfolioItemTypes {
  INSTRUMENT = 'issues',
  ENTITY = 'issuers',
  COMMENTARY = 'commentaries',
  COMPANY_NEWS = 'companyNews',
  RATING_NEWS = 'ratingNews',
  RESEARCH = 'researches',
  MONITORING_NOTES = 'monitoringNotes',
}

export const consolidatedPortfolioItemTypes: Partial<Record<
  portfolioItemTypes,
  portfolioItemTypes[]
>> = {
  [portfolioItemTypes.RATING_NEWS]: [
    portfolioItemTypes.RATING_NEWS,
    portfolioItemTypes.MONITORING_NOTES,
  ],
  [portfolioItemTypes.RESEARCH]: [portfolioItemTypes.RESEARCH, portfolioItemTypes.COMMENTARY],
  [portfolioItemTypes.INSTRUMENT]: [portfolioItemTypes.INSTRUMENT],
  [portfolioItemTypes.ENTITY]: [portfolioItemTypes.ENTITY],
};
